export default {
    headerPlaceholder: 'Header',
    placeholder: 'Enter a description...',
    Alt: 'Alternative text',
    Caption: 'Caption',
    Author: 'Author',
    Quote: 'Quote',
    messages: {
        ui: {
            blockTunes: {
                toggler: {
                    'Click to tune': 'Click to tune',
                },
            },
            toolbar: {
                toolbox: {
                    Add: 'Add',
                },
            },
            inlineToolbar: {
                converter: {
                    'Convert to': 'Convert to',
                },
            },
            popover: {
                Filter: 'Filter',
            },
        },
        toolNames: {
            Text: 'Text',
            Heading: 'Heading',
            List: 'List',
            Image: 'Image',
            Quote: 'Quote',
            Gallery: 'Gallery',
        },
        tools: {
            list: {
                Ordered: 'Ordered',
                Unordered: 'Unordered',
            },
            heading: {
                'Heading 1': 'Heading (H1)',
                'Heading 2': 'Heading (H2)',
                'Heading 3': 'Heading (H3)',
            },
            quote: {
                'Align Left': 'Align left',
                'Align Center': 'Alignment to the center',
            },
            image: {
                Alt: 'Alternative text',
                Caption: 'Image description',
            },
        },
        blockTunes: {
            delete: {
                Delete: 'Delete',
                'Click to delete': 'Click to delete',
            },
            moveUp: {
                'Move up': 'Up',
            },
            moveDown: {
                'Move down': 'Down',
            },
        },
    },
    gallery: {
        title: 'Gallery title',
        description: 'Description',
        imageUpload: 'Upload image(s)',
        delete: 'Delete',
        deleteAll: 'Delete All',
    },
};
